<script>
import Button from "@/components/atoms/button";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";

export default {
  name: "PlanningCommunesSelector",
  components: { Button, List, ListItem },
  props: {
    communes: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    showFilter: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["communeSelected"],
  computed: {
    letters() {
      const letters = this.communesSansDoublons.map((commune) => {
        return commune.attributes.nom_commune.charAt(0);
      });
      return (
        letters.length > 0 &&
        letters.reduce((acc, current) => {
          return acc.includes(current) ? acc : [...acc, current];
        })
      );
    },
    communesFiltered() {
      if (this.currentLetter) {
        return this.communesSansDoublons.filter((commune) => {
          return (
            commune.attributes.nom_commune.indexOf(this.currentLetter) === 0
          );
        });
      }
      return this.communesSansDoublons;
    },
    communesSansDoublons() {
      return this.communes
        .reduce((acc, current) => {
          const inAcc = acc.some(
            (item) =>
              item.attributes.code_insee === current.attributes.code_insee
          );
          return inAcc ? acc : [...acc, current];
        }, [])
        .sort((a, b) => {
          return a.attributes.nom_commune > b.attributes.nom_commune ? 1 : -1;
        });
    }
  },
  data() {
    return {
      currentLetter: null
    };
  },
  methods: {
    filterByLetter(letter) {
      this.currentLetter = letter;
    },
    communeSelected(commune) {
      this.$emit("communeSelected", commune);
    }
  }
};
</script>

<template>
  <div class="c-planning-communes-selector">
    <div
      v-if="showFilter"
      class="c-planning-communes-selector__filter u-mb-sm"
    >
      <List class="c-planning-communes-selector__filter-list">
        <ListItem
          v-for="(letter, index) in letters"
          :key="`letter-${index}`"
          class="c-planning-communes-selector__filter-item"
        >
          <Button
            :class="currentLetter === letter && 'c-planning-communes-selector__filter-item-action--active'"
            class="c-planning-communes-selector__filter-item-action"
            @click="filterByLetter(letter)"
          >
            {{ letter }}
          </Button>
        </ListItem>
      </List>
    </div>
    <List class="c-planning-communes-selector__list">
      <ListItem
        v-for="commune in communesFiltered"
        :key="commune.id"
        class="c-planning-communes-selector__list-item"
      >
        <Button
          link
          variant="text-light"
          align="left"
          @click="communeSelected(commune)"
        >
          {{ commune.attributes.nom_commune }} ({{ commune.attributes.code_postal }})
        </Button>
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/c-planning-communes-selector.scss";
</style>
